import React, { useEffect, useState } from "react";
import InstructorCardForCourseAssignment from "../InstructorCardForCourseAssignment/InstructorCardForCourseAssignment";
import {
  getAllInstructorsAPI,
  courseAssignmentAPI,
} from "../../redux/features/globalFuncSlice";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import DottedLoading from "../DottedLoading/DottedLoading";

export default function CourseAssignmentToInstructor({ courseAssignId }) {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);

  const [allInstructor, setAllInstructor] = useState([]);
  const [searchFilter, setSearchFilter] = useState("");
  const [courseAssignmentToInstrcutor, setCourseAssignmentToInstrcutor] =
    useState(0);
  const courseAssignmentLoading = useSelector(
    (state) => state.globalFunc.courseAssignmentLoading
  );

  const navigate = useNavigate();

  useEffect(() => {
    setCourseAssignmentToInstrcutor(courseAssignId);
  }, [courseAssignId]);

  useEffect(() => {
    const fetchAllInstructor = async () => {
      const res = await dispatch(
        getAllInstructorsAPI({ token: auth.token })
      ).unwrap();
      if (res.success) {
        const filteredData = res.data.details.filter(
          (item) => item.status === "complete"
        );
        setAllInstructor(filteredData);
      }
    };

    fetchAllInstructor();
  }, []);

  const courseAssignmentHandler = async () => {
    let courseId = localStorage.getItem("course_creation_id");
    let payload = {
      instructor_id: courseAssignmentToInstrcutor,
    };
    const res = await dispatch(
      courseAssignmentAPI({ token: auth.token, course_id: courseId, payload })
    ).unwrap();
    if (res.success) {
      toast.success(res.message);
      navigate("/course-detail");
      localStorage.removeItem("uploadedImages")
      localStorage.removeItem("uploadedVideos")
      localStorage.removeItem("uploadedDocuments")
      localStorage.removeItem("course_creation_id")
    }
  };

  const filteredInstructors = allInstructor.filter((item) =>
    item.full_name
      ? item.full_name.toLowerCase().includes(searchFilter.toLowerCase())
      : false
  );

  return (
    <div>
      <div className="card-default-style step-form-holder">
        <div className="px-0 px-sm-10 px-md-25 ">
          <div className="mb-40 d-flex justify-content-between align-items-center gap-2">
            <h3 className="ad-heading-05 fw-bold black-900 mb-0">
              Instructors
            </h3>
            <div className="d-flex align-items-center flex-wrap">
              <div className="position-relative search-wrapper-2 me-10 mb-10 mb-sm-0">
                <input
                  type="text"
                  className="form-control pe-30"
                  placeholder="Search Instructors"
                  value={searchFilter}
                  onChange={(e) => setSearchFilter(e.target.value)}
                />
                <span className="icon-search position-absolute "></span>
              </div>
            </div>
          </div>
          <div className="row instructor-item-list flex-wrap">
            {filteredInstructors.length > 0 ? (
              filteredInstructors.map((item, index) => (
                <div className="col" key={index}>
                  <InstructorCardForCourseAssignment
                    courseAssignmentToInstrcutor={courseAssignmentToInstrcutor}
                    setCourseAssignmentToInstrcutor={
                      setCourseAssignmentToInstrcutor
                    }
                    data={item}
                  />
                </div>
              ))
            ) : (
              <div className="alert alert-info">No instructors found</div>
            )}
          </div>
          {courseAssignmentToInstrcutor > 0 && (
            <div className="mt-24 text-end">
              <button
                type="button"
                className="btn btn-primary no-shadow"
                onClick={courseAssignmentHandler}
                disabled={courseAssignmentLoading}
              >
                {courseAssignmentLoading ? (
                  <DottedLoading />
                ) : (
                  "Assign Instructor"
                )}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
